import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "counter",
  initialState: {
    userDetails: "default",
    userData: "default",
    userId: "0",
    siteId: "0",
    candidateData: "default",
    candidateId: "0"
  },

  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setSiteId: (state, action) => {
      state.siteId = action.payload;
    },
    setSiteHrmsFlag: (state, action) => {
      state.HrmsFlag = action.payload;
    },
    setCandidateData: (state, action) => {
      state.candidateData = action.payload;
    },
    setCandidateId: (state, action) => {
      state.candidateId = action.payload;
    }
  },
});

export const { setUserDetails, setUserData, setSiteId, setUserId, setSiteHrmsFlag, setCandidateData, setCandidateId } =
  loginSlice.actions;

export default loginSlice.reducer;
